<template>
<div class="page page_publishDZ">
    <!-- banner -->
    <div class="top_wrap">
        <img :src="publicPath+'statics/images/dingzhi/banner_publish.png'" alt="" class="banner">
    </div>
    <!-- 发布信息 -->
    <div class="xinxi" v-if="detail != null">
        <div class="item">
            <div class="item_l">
                <span class="">商品标题：</span>
            </div>
            <div class="item_r">
                <van-field v-model="detail.title" readonly  />
            </div>
        </div>
        <div class="item">
            <div class="item_l">
                <span class="">商品类型：</span>
            </div>
            <div class="item_r" >
                <van-field v-model="detail.skill.name" readonly />
            </div>
        </div>
        <div class="item textarea">
            <div class="item_l">
                <span class="">商品描述：</span>
            </div>
            <div class="item_r">
                <van-field type="textarea" v-model="detail.describe" readonly />
            </div>
        </div>
        <!-- 上传图片 -->
        <div class="uploadTu">
            <div class="title">定制图片</div>
            <div class="upload-images">
                <div class="img-box" v-for="(item, index) in imglist" :key="index">
                    <div class="icon-po">
                        <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+item" @click="zhanshitupian(imglist,index)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <van-image-preview v-model="bigTuShow" :start-position="bigTuIndex" :images="bigTuImgArr" @change="bigTuChange"></van-image-preview>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
            id: this.$route.query.id,
            detail: null,
            imglist: [],
            bigTuShow: false,
            bigTuIndex: 0,
            bigTuImgArr: null,
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '我要定制'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.specialDetail()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            this.specialDetail()
        }
    },
    methods: {
        // 我要定制详情
        specialDetail() {
            var params = {
                token: this.token,
                id: this.id
            }
            this.$api.dingzhi.specialDetail(params).then(res => {
                if (res.code == 200) {
                    this.detail = res.result
                    this.imglist = res.result.album.split(",")
                }
            })
        },
        // 展开大图 
        zhanshitupian(arr, index) {
			for(let i in arr){
				arr[i] = this.imageUrl+arr[i];
			}
            this.bigTuImgArr = arr;
            this.bigTuIndex = index;
            this.bigTuShow = true;
        },
        // 切换大图
        bigTuChange(index) {
            this.bigTuIndex = index
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
